// mutations.js

export default {
   updateSystemList(state, systems){
       state.systemList = systems
   },
    updateCurrentSystem(state, site){
        state.currentSystem.name = site.name
        state.currentSystem.value = site.value
    },
    updateShowHeaderSystemFilter(state, payload){
       state.showHeaderSystemFilter = payload
    }
    
};
